import React from "react";
import PropTypes from "prop-types";
import { FormattedMessageAnchor, Image } from "../../commonComponents";
import Modal from '../baseModal'
import configData from "Content/content.json";
import Home from "../../../assets/imgs/new/shop_icons/acuvue_to_home.png";
import Qoo10 from "../../../assets/imgs/new/shop_icons/qoo10_logo.png";
import Shopee from "../../../assets/imgs/new/shop_icons/shopee_logo.png";
import Lazada from "../../../assets/imgs/new/shop_icons/lazada_logo.png";

const TYPE = "buy";
const envLanguage = process.env.REACT_APP_LOCALE || "en";

const buyModalData = {
  title: TYPE,
  content: configData["data"][TYPE][envLanguage]
};
const images = {
  Home,
  Qoo10,
  Shopee,
  Lazada
};
const title = {
  id: buyModalData.title === "buy" ? "modal.buy" : "modal.free_trial",
  defaultMessage: buyModalData.title === "buy" ? "Buy" : "Free Trial"
};
const BuyModal = ({ onClose }) => (
  <Modal onClose={onClose} title={title} modalType="buy">
    <ul className="lists">
      {buyModalData.content.map(({ id, name, url }, index) => (
        <li className="lists--item" data-layer-menu_item="lists--item" key={index}>
          {images[id] ? (
            <Image className="icons--modal-logo" src={images[id]} />
          ) : (
            name
          )}
          {buyModalData.title === "buy" ? (
            <FormattedMessageAnchor
              className="text-uppercase"
              href={url}
              target="_blank"
              id="modal.shop_now"
              defaultMessage="Shop Now"
              className="link"
            />
          ) : (
            <FormattedMessageAnchor
              className="text-uppercase"
              href={url}
              target="_blank"
              id="modal.go"
              defaultMessage="Go"
              className="link"
            />
          )}
        </li>
      ))}
    </ul>
  </Modal>
);

BuyModal.propTypes = {
  onClose: PropTypes.func
};

export default BuyModal;
